export default {
    namespaced: true,

    state: {
        id: null,
        products: {},
        supplier: {},
        customer: {},
        shipping: {},
        schedule: {},
        accounting: {},
        forms: {},
    },

    getters: {
        subContractId: state => state.id,
        tabData: state => tab => state[tab] || {},
    },

    mutations: {
        SET_ID(state, id) {
            state.id = id;
        },
        SET_TAB(state, { tab, data }) {
            state[tab] = { ...state[tab], ...data };
        },
        RESET(state) {
            state.id = null;
            ['products','supplier','customer','shipping','schedule','accounting','forms']
                .forEach(k => { state[k] = {}; });
        },
    },

    actions: {
        load({ commit, state }, id) {
            if (state.id !== id) commit('RESET');
            commit('SET_ID', id);
        },
        saveTab({ commit }, payload) {
            commit('SET_TAB', payload);
        },
    },
};